import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import { AysCodeGroup } from '@bindoc-projects/code-domain-lib';

export const BD_OPS_GROUP_CONTENT_CONDITION_ID = 'opsGroup';
export const FilterConditionOpsCodeGroupPluginType: FilterConditionPluginSpecification<
  AysCodeGroup[],
  FilterConditionOpsCodeGroupDto,
  BdOpsGroupContentCondition
> = {
  type: 'opsGroup',
  category: 'case',
  displayName: { de: 'OPS-Gruppe' },
  sortingIndex: 9,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionOpsCodeGroupDto,
  ): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionOpsCodeGroupPlugin(
        obj.groups.map((it) => AysCodeGroup.fromObject(it)),
      );
  },
  fromCondition(
    jsonObj: BdOpsGroupContentCondition,
  ): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionOpsCodeGroupPlugin(
        (jsonObj.includes ?? []).map((it) => AysCodeGroup.fromObject(it)),
      );
  },
  newInstance(): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionOpsCodeGroupPlugin([]);
  },
};

export class FilterConditionOpsCodeGroupPlugin extends FilterConditionPluginImpl<
  AysCodeGroup[],
  FilterConditionOpsCodeGroupDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    AysCodeGroup[],
    FilterConditionOpsCodeGroupDto,
    BdOpsGroupContentCondition
  > = FilterConditionOpsCodeGroupPluginType;

  constructor(private groups: AysCodeGroup[]) {
    super(FilterConditionOpsCodeGroupPluginType.type);
  }

  clone(): FilterConditionOpsCodeGroupPlugin {
    return new FilterConditionOpsCodeGroupPlugin([
      ...this.groups.map((it) => it.clone()),
    ]);
  }

  override equals(other: FilterConditionOpsCodeGroupPlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(
        this.groups,
        other.groups,
        (a, b) => a.name === b.name && a.codingSystem === b.codingSystem,
      )
    );
  }

  override validationToText(): string {
    if (this.groups.length === 0) {
      return 'Mindestens eine OPS-Gruppe auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new BdOpsGroupContentCondition(this.groups, []);
  }

  toJSON(): FilterConditionOpsCodeGroupDto | null {
    return {
      type: this.type,
      groups: this.groups,
    };
  }

  toText(): string | null {
    return 'OPS-Gruppe';
  }

  toValue(): AysCodeGroup[] {
    return this.groups;
  }
}

export class BdOpsGroupContentCondition extends BdContentCondition<AysCodeGroup> {
  constructor(includes: AysCodeGroup[], excludes: AysCodeGroup[]) {
    super(BD_OPS_GROUP_CONTENT_CONDITION_ID, includes, excludes);
  }
}

interface FilterConditionOpsCodeGroupDto {
  type: string;
  groups: AysCodeGroup[];
}
